import { FormHelperText } from '@material-ui/core';


const Required = ({ required = false, message = "This field is required", children, color = 'red' }) => {
  if (!required) return children;
  return (
    <div className="required-wrapper" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', border: `2px solid ${color}` }}>
      {children}
      <FormHelperText style={{ color: color, maxWidth: '200px', textAlign: 'center' }}>{message}</FormHelperText>
    </div>
  );
}

export default Required; 